import styled from "styled-components";

export const Styles = styled.div`
  .group-btn {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    padding: 16px;
    background-color: white;
    justify-content: flex-end;
  }
  .container-wrapper {
    background-color: #fff;
    padding: 2rem;
  }
`;
